
const Lines = ({
    count = 10,
    rotateDeg,
    skewParent = 0,
    color = "white",
    spacing,
    thickness = 700,
    fontSize = "1rem",
    skew = 0,

}) => {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", transform: `skewX(${skewParent}deg)` }}>
            <span
                style={{
                    letterSpacing: spacing,
                    transform: `rotate(${rotateDeg}deg) skew(${skew}deg)`,
                    color: color,
                    fontWeight: thickness,
                    fontSize: `${fontSize}rem`,
                }}
            >
                {"/".repeat(count)}
            </span>
        </div>
    );
};

export default Lines;
